import { render } from "./DateTimePicker.vue?vue&type=template&id=1753b1ec"
import script from "./DateTimePicker.vue?vue&type=script&lang=js"
export * from "./DateTimePicker.vue?vue&type=script&lang=js"
script.render = render

export default script